export function parseTicketCode (content) {
  if (!content || typeof content !== 'string') {
    return null
  }
  let code = content.trim()
  if (code.match(/^https[Öö]/)) {
    code = code.replace(/[Öö]/g, ':')
      .replace(/[\-_]/g, '/')
      .replace(/[Ää]/g, '-')
  }
  if (code.match(/^HTTPS:/)) {
    code = code.replace(/\w{1}/g, function (val) {
      return val === val.toLowerCase() ? val.toUpperCase() : val.toLowerCase()
    })
  }
  let shopId = false
  let identifier = false
  const found = code.match(/https:\/\/[a-z0-9\-\.]+\/([^\/]+)\/qr\/([^\/]+)/)
  if (found) {
    shopId = found[1]
    identifier = found[2]
  } else if (code.match(/.+\/.+/)) {
    const tArr = code.split('/')
    shopId = tArr[0]
    identifier = tArr[1]
    if (shopId !== shopId.toLowerCase()) {
      shopId = shopId.toLowerCase()
      identifier = identifier.replace(/\w{1}/g, function (val) {
        return val === val.toLowerCase() ? val.toUpperCase() : val.toLowerCase()
      })
    }
  }
  if (!shopId || !identifier) {
    return null
  }
  return { shopId, identifier, type: identifier.charAt(0) }
}

export function isTicketQrCode (content) {
  const parsed = parseTicketCode(content)
  return !!(parsed && (parsed.type === 'R' || parsed.type === 'S'))
}
